/*
 * Copyright (c) 2025 curryfirm.com
 */

import { getAllPermutations, locationsToRouteArgs, computeRoute, toDumpAndBackSequenceToMoves } from './helpers.js';
import { getSwapDropRoute } from './getSwapDropRoute.js';
import { findOptimalToDumpAndBackRoute } from "./routing/findOptimalToDumpAndBackRoute.js";
import { ROUTE_TYPES } from "../constants.js";

const findOptimalRoute = async (routingParams, options = {}) => {
    const { routeType, startLoc, endLoc, dumpsters, dumps, } = routingParams;
    const { signal } = options;
    let best = null;

    switch (routeType) {
        case ROUTE_TYPES.SWAP_AND_DROP:
            const perms = getAllPermutations(dumpsters);
            for (const orderOfDumpsters of perms) {
                const {totalLength, moves, locationSequence}
                    = await getSwapDropRoute(startLoc, endLoc, orderOfDumpsters, dumps, {signal});
                if (!best || totalLength < best.totalDistance) {
                    best = {totalLength, moves, locationSequence};
                }
            }
            break;

        case ROUTE_TYPES.TO_DUMP_AND_BACK:
            // The starting point for this type is always a location.
            // The first step is always { from: start, action: 'TO_DUMPSTER', to: dumpsterLocation }
            best = await findOptimalToDumpAndBackRoute(routingParams, { signal });
            best.moves = toDumpAndBackSequenceToMoves(best.locationSequence);
            break;

        default:
            throw new Error("findOptimalRoute: unknown route type");
    }
    const { start, end, stops } = locationsToRouteArgs(best.locationSequence);
    const routeApiJsonResult = await computeRoute(start, end, stops, { signal });
    return { totalLength: best.totalLength, moves: best.moves, routeApiJsonResult };
}

export default findOptimalRoute;